import { SiteLocale } from '@graphql/generated';
import de from './labels/de.json';
import en from './labels/en.json';
import es from './labels/es.json';
import fr from './labels/fr.json';
import it from './labels/it.json';

export type Labels = keyof typeof en;
const allLabels: Record<SiteLocale, Record<Labels, string>> = { en, it, de, fr, es };

function t(locale: SiteLocale, label: Labels) {
  let text = locale + ' - ' + label;
  if (allLabels[locale] && allLabels[locale][label]) {
    text = allLabels[locale][label];
  }
  return text;
}

export function tt(locale: SiteLocale, label: Labels, params: Record<string, string>) {
  let text = t(locale, label);
  for (const [key, value] of Object.entries(params)) {
    text = text.replace(`#${key}`, value);
  }
  return text;
}

export default t;
